import loadingIcon from '../../images/loading.gif';
import './stepButton.scss';
import cn from 'classnames';

const StepButton = ({
    onClick,
    className,
    label,
    blue,
    icon,
    red,
    fontSize,
    social,
    disabled,
    type,
    dark,
    id,
    isLeftIcon,
    leftIcon,
    gray,
    redWithBorder,
    isLoading = false,
    labelClassName = false,
}) => {
    return (
        <>
            <div
                className={cn(
                    'step-button-default',
                    {
                        'step-button-blue': blue,
                        'step-button-gray': gray,
                        'step-button-red': red,
                        'step-button-with-border-red': redWithBorder,
                        'step-button-social': social,
                        'step-button-dark':
                            (!blue && !gray && !red && !redWithBorder && !social) || dark, // default class
                        'step-disabled-button': disabled,
                        'step-enabled-button': !disabled,
                        'step-button-loading': isLoading,
                    },
                    labelClassName
                )}
            >
                <button
                    disabled={disabled}
                    type={type}
                    id={id}
                    onClick={(event) => {
                        if (disabled || isLoading) {
                            return;
                        }
                        if (onClick) {
                            onClick(event);
                        }
                    }}
                    // style={disabled && {cursor:"not-allowed"}}
                    className={className}
                >
                    {isLoading && false ? (
                        <div className="d-flex justify-content-center p-0">
                            <img src={loadingIcon} className={'loadingIcon'} />
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center">
                            <div className={fontSize ? 'button-font d-flex' : 'd-flex'}>
                                {isLoading ? (
                                    <img src={loadingIcon} className={'loadingIcon'} />
                                ) : (
                                    <>
                                        {isLeftIcon && (
                                            <div className="leftIcon my-auto">{leftIcon}</div>
                                        )}
                                        <div className="btnTitle my-auto">{label}</div>
                                    </>
                                )}
                            </div>
                            <div
                                className={
                                    social
                                        ? 'social-icon'
                                        : 'd-flex justify-content-center align-items-center'
                                }
                            >
                                {icon}
                            </div>
                        </div>
                    )}
                </button>
            </div>
        </>
    );
};

export default StepButton;
